module.exports = __webpack_public_path__ + "media/the_solution.d6597c39.mp4";